import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {SalesWorkflowSteps, SalesWorkflow} from "projects/store/src/app/enums";
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {ActivatedRoute} from "@angular/router";
import {CustomMessageService} from "library";
import {TrafficSource} from "projects/store/src/app/enums/traffic-source.enum";
import {SalesWorkflowService} from "projects/store/src/app/services/api/v1/sales-workflow.service";
import {MacroFlowService} from "projects/store/src/app/services/api/v1/macro-flow.service";

enum Options {
  "brands" = "brands",
  "percentage" = "percentage",
  "products" = "products",
}

@Component({
  selector: 'app-sales-navigation-bar',
  templateUrl: './sales-navigation-bar.component.html'
})
export class SalesNavigationBarComponent implements OnInit{
  private readonly  requestService = inject(RequestService);
  private readonly  salesWorkflowService = inject(SalesWorkflowService);
  private readonly  route = inject(ActivatedRoute);
  private readonly customMessageService = inject(CustomMessageService);
  private readonly macroFlowService = inject(MacroFlowService);

  private requestId: any;
  protected flowCode: any;
  source!: string
  request = this.requestService.request;
  autogestionTienda = this.macroFlowService.getAutogestionTiendaFlow();
  domicilioVendedor = this.macroFlowService.getAddressSalesFlow();
  generalTienda = this.macroFlowService.getGeneralTiendaFlow();
  gestionTienda = this.macroFlowService.getGestionTiendaFlow();

  @Input() activeStep!: Options | any;
  @Input() activeStepStore!: any;
  @Input() activeStepCategories!: any;
  @Input() selectedCategory: any;
  @Input() visitedSteps: Set<Options | any> = new Set();
  @Input() visitedSteps2: Set<any> = new Set();
  Options = Options;
  steps: Options[] = [Options.brands, Options.percentage, Options.products];

  @Output() gotoStepEvent = new EventEmitter();
  @Output() gotoStepEventNavigator = new EventEmitter();
  @Output() stepChange = new EventEmitter<Options>();

  ngOnInit(){
    this.requestId = this.route.snapshot.params['request_id'];
    this.flowCode = this.route.snapshot.params['flow_code'];
    this.load();
    console.log(this.activeStepCategories);
  }


  load(){
    this.source = this.request['source'];
  }

  goToStep(step: Options) {
    if (this.visitedSteps.has(step)) {
      this.gotoStepEvent.emit(step);
    }
  }

  gotoStepCategory(stepCode: string) {
    // Determinar el código de flujo con una expresión ternaria
    const flowCode = this.flowCode === this.domicilioVendedor
      ? this.domicilioVendedor
      : this.macroFlowService.getPreviousFlowInMacro(this.flowCode) ?? '';
      
    // Emitir el evento con los parámetros
    this.gotoStepEventNavigator.emit({ flowCode, stepCode });
  }


  protected readonly SalesWorkflowSteps = SalesWorkflowSteps;
  protected readonly SalesWorkflow = SalesWorkflow;
  protected readonly TrafficSource = TrafficSource;
}
